export default (function (siteVariables) {
  return {
    color: siteVariables.colors.grey[250]
  };
});
//# sourceMappingURL=headerDescriptionVariables.js.map
